<template>
  <div>
    <a
      class="text-blueGray-500 py-1 px-3"
      href="#pablo"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <i class="fas fa-ellipsis-v"></i>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        @click="(e) => {$emit('view-click', e); toggleDropdown(e)}"
      >
        <i class="pi pi-eye text-xs"></i> View
      </a>
      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        @click="(e) => {$emit('edit-click', e); toggleDropdown(e)}"
        v-if="has('plans.store') || has('plans.update')"
      >
        <i class="pi pi-file-edit text-xs"></i> Edit
      </a>
      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        @click="(e) => {$emit('deactivate-click', e); toggleDropdown(e)}"
        v-if="has('plans.store') || has('plans.update')"
      >
        <i class="pi text-xs" :class="plan.is_active ? 'pi-eye-slash' : 'pi-eye'"></i> {{ plan.is_active ? 'Deactivate' : 'Activate' }}
      </a>
      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-red-500"
        @click="(e) => {$emit('delete-click', e); toggleDropdown(e)}"
        v-if="has('plans.destroy')"
      >
        <i class="pi pi-times-circle text-xs"></i> Delete
      </a>
    </div>
    <div v-if="dropdownPopoverShow" @click="toggleDropdown($event)" style="width: 100%; opacity: 0.25;" class="opacity-25 fixed inset-0 z-30 h-screen top-0 left-0 bg-black"></div>
  </div>
</template>
<script>
import { createPopper } from "@popperjs/core";

export default {
  props: ["plan"],
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  methods: {
    toggleDropdown: function (event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    }
  }
};
</script>
